import { authApi } from '../clients/AxiosClients'

const buscarDadosParaTelaDeRecuperacaoDeSenha = async (usuarioId) => {
	return await authApi.get(
		`/api/v1/account/recuperar-informacoes-do-usuarios-para-tela-de-redefinicao-de-senha?userId=${usuarioId}`,
	)
}

const enviarEmailParaRedefinirSenha = async (data) => {
	return await authApi.post('/api/v1/account/enviar-email-para-resetar-senha', data)
}

const redefinirSenha = async (data) => {
	return await authApi.post('/api/v1/account/redefinir-senha', data)
}

export { buscarDadosParaTelaDeRecuperacaoDeSenha, enviarEmailParaRedefinirSenha, redefinirSenha }
